var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccessCodeFilled = function SvgAccessCodeFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.345 6H4.655c-1.05 0-1.905.855-1.905 1.905v8.205c0 1.05.855 1.905 1.905 1.905h15.69c1.05 0 1.905-.855 1.905-1.905V7.905c0-1.05-.855-1.905-1.905-1.905Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.28 10.774v2.442M6.218 12.606l2.112-1.221M8.33 12.606l-2.112-1.221M12.506 10.774v2.442M11.456 12.606l2.112-1.221M13.568 12.606l-2.112-1.221M17.744 10.774v2.442M16.694 12.606l2.113-1.221M18.807 12.606l-2.113-1.221",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
};
export default SvgAccessCodeFilled;